import Header from "../Header";
import Nav from "../Nav";
import About from "../About";
import Hire from "../Hire";
import Courses from "../Courses";
import Technologies from "../Technologies";
import Projects from "../Projects";
import Footer from "../Footer";
import { Container } from "./styles"

function Layout(props) {
  return (
    <Container>


      <Header />
      <Nav />



      <main>

        <About />
        <Hire />
        <Courses />
        <Technologies />
        <Projects />

      </main>

      <Footer />



    </Container>


  );
}

export default Layout 
